import React, {  useCallback, useState }from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import EditIcon from '@process-advisor/assets/editIcon.png'
import DeleteIcon from '@process-advisor/assets/deleteIcon.png'

import ExportIcon  from '@process-advisor/assets/export.png'
import CSVIcon  from '@process-advisor/assets/CSVIcon.png'
import ExcelIcon  from '@process-advisor/assets/XLSIcon.png'

const Wrapper = styled.div`
    width: 100%;
    padding: 10px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    type: string;
    supress_menu: boolean;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    type,
    supress_menu
}) => {

    const costContextMenuItems = useCallback((params) => {
        var result = [
            {
                name: 'Delete',
                action: function () {
                    apiProvider.deleteCost(({costID: params.node.data.costID }))
                },
                icon:'<img src="' + DeleteIcon + '" />',
              },
              {
                name: 'Edit',
                action: function () {
                    apiProvider.editCostModal(({ costID: params.node.data.costID }))
                },
                icon:'<img src="' + EditIcon + '" />',
              },      
              {
                name: 'Export',
                icon: '<img src="' + ExportIcon + '" />',
                subMenu: [
                    {
                        name: 'CSV Export (all)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'CSV Export (selected)',
                        action: () => params.api.exportDataAsCsv(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + CSVIcon + '" />',
                    },
                    {
                        name: 'XLS Export (all)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: false}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                    {
                        name: 'XLS Export (selected)',
                        action: () => params.api.exportDataAsExcel(
                            {onlySelected: true}
                          ),
                        icon: '<img src="' + ExcelIcon + '" />',
                    },
                ],
            },        
    

        ];
        return result;
      }, []);    

    let getContextMenuItems
    let showTotals = false
    if (type === 'cost' ) {getContextMenuItems = costContextMenuItems; }

    const [savestate, setSavestate] = useState(false);

    const onSaveGridColumnState = (params) => {
        if (savestate === true) {
            let columnState = params.api.getColumnState();
            apiProvider.saveCostsGridState({columnState})
        }
        setSavestate(true)
    }

    const onFirstDataRendered  = (params) => {
        if (apiProvider.getCostsGridState() != null) params.api.applyColumnState(apiProvider.getCostsGridState());
    };

    React.useEffect(() => {
        setSavestate(false)
    }, []);


    return (
        <Wrapper>
            <div
                
                style={{
                    height: '100%',
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    onFirstDataRendered={onFirstDataRendered}
                    onFilterChanged={onSaveGridColumnState}
                    onColumnVisible={onSaveGridColumnState}
                    onColumnResized={onSaveGridColumnState}
                    onSortChanged={onSaveGridColumnState}
                    masterDetail={true}
                    rowSelection="single"
                    headerHeight={45}
                    columnDefs={columns}
                    groupIncludeTotalFooter={showTotals}
                    getContextMenuItems={getContextMenuItems}
                    suppressContextMenu={supress_menu}
                    domLayout='autoHeight'
                    detailRowAutoHeight = {true}
                    overlayNoRowsTemplate={'No costs exist'}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                        wrapText: true,
                        autoHeight: true,
                    }}
                    sideBar={
                        {
                            toolPanels: [
                                {
                                    id: 'columns',
                                    labelDefault: 'Columns',
                                    labelKey: 'columns',
                                    iconKey: 'columns',
                                    toolPanel: 'agColumnsToolPanel',
                                    toolPanelParams: {
                                        suppressRowGroups: true,
                                        suppressValues: true,
                                        suppressPivotMode: true, 
                                    }
                      
                                },
                                {
                                    id: 'filters',
                                    labelDefault: 'Filters',
                                    labelKey: 'filters',
                                    iconKey: 'filter',
                                    toolPanel: 'agFiltersToolPanel',
                                },
                            ],
                            hiddenByDefault: false,
                            defaultToolPanel: '',
                        }
                    }   
                    detailCellRendererParams={{
                        detailGridOptions: {
                            pagination: true,
                            paginationAutoPageSize: true,
                            suppressRowClickSelection: true,
                            headerHeight: 0,
                            columnDefs: [
                                {
                                    field: 'header',
                                    headerName: 'header',
                                    hide: true,
                                },
                                {
                                    field: 'text',
                                    headerName: 'text',
                                },
                            ],
                            defaultColDef: {
                                flex: 1,
                                sortable: true,
                                filter: true,
                                resizable: true,
                                wrapText: true,
                                autoHeight: true,
                            },
                            rowClassRules: {
                                'discovery-rules-header': function(params) { return params.data.header === 1; },
                            },
                        },
                        getDetailRowData: params => {
                            params.successCallback(params.data.details);
                        },
                    }}
                    rowData={rows} />
            </div>
        </Wrapper>
    );
};
